export enum PosTestIds {
  CONTAINER = 'pos-container',
  SEND_LATER_BUTTON = 'send-pos-later-button',
}
